import { atom } from "recoil";

export const PROMO_BONUS_TRANSLATION_TYPES = [
	{ value: "local", label: "local" },
	{ value: "international", label: "international" },
	{ value: "mixed", label: "mixed" },
];

export const MAX_PROMO_BONUS_BANNER_BYTES = 1024 * 1024;

export const promoBonusesStore = atom({
	key: "promoBonusesStore",
	default: {
		loaded: false,
		data: [],
		statistics: {
			loaded: false,
			data: [],
			summary: {
				clicks: 0,
				clickToTarget: 0,
				issuedAmount: 0,
				issuedAmountRub: 0,
				targetActions: 0,
				viewToClick: 0,
				views: 0,
			},
		},
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});

export const promoBonusEditModalStore = atom({
	key: "promoBonusEditModalStore",
	default: {
		show: false,
		key: "",
		kind: "",
		contactType: "",
		enabled: false,
		sort: "",
		bannerUrl: "",
		bannerPreviewUrl: "",
		title: "",
		titleType: { value: "local", label: "local" },
		subtitle: "",
		subtitleType: { value: "local", label: "local" },
		buttonText: "",
		buttonTextType: { value: "local", label: "local" },
		linkUrl: "",
		amount: "",
		depositRequired: false,
		depositFrom: "",
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
